<div class="d-flex flex-grow flex-column content-block">
  <app-upload-data
    *ngIf="orderId"
    [orderId]="orderId"
    class="d-flex flex-grow flex-column"
  ></app-upload-data>
</div>
